/* eslint-disable no-unused-vars */
const { AbilityBuilder, Ability } = require('@casl/ability');
const abilitiesJson = require('../../build_data/abilityMatrix.json');

const defineRolebilities = (role, can, cannot, rules, user) => {
  const roleMatrix = abilitiesJson[role];
  roleMatrix.forEach((ability) => {
    if (ability.value) {
      can(ability.action, ability.subject);
    } else {
      cannot(ability.action, ability.subject);
    }
  });
};

function defineGuestUserAbilities(can, cannot, rules, user) {
  cannot('graph', 'GraphCombos');
  cannot('graph', 'GraphNodes');
  cannot('graph', 'GraphNodeDetails');
  cannot('graph', 'GraphCategorization');
  cannot('graph', 'GraphShortestPath');
  cannot('graph', 'GraphExploreInPlace');
  cannot('graph', 'GraphNoteAddAsNode');

  cannot('note', 'VideoUpload');
  cannot('note', 'ScreenRecording');
  can('note', 'ImageUpload');

  can('read|create|edit|delete', 'Graphs');
  can('read|create|edit|delete', 'Note');

  can('read|create|edit|delete', 'Tag');

  can('read|create|edit|delete', 'Quest');

  can('load', 'all');
  can('access', 'all');
  cannot(['access', 'load'], 'TreasureMarker');
  cannot('load', 'ThreeDModelViewer');
  cannot('load', 'ThoughtMarkdown');
  cannot('load', 'GraphExploreVR');
  cannot(['resize', 'rearrange'], 'Layout');
  can('create', 'Panel');
}

function defineAbilitiesFor(user) {
  const { can, cannot, rules } = new AbilityBuilder(Ability);

  const roles = user.roles || [];
  console.log({ roles });
  const rolesMatrix = Object.keys(abilitiesJson);
  defineGuestUserAbilities(can, cannot, rules, user); // A starting set

  // Now for each type
  rolesMatrix.forEach((role) => {
    if (roles.includes(role)) {
      defineRolebilities(role, can, cannot, rules, user);
    }
  });
  console.log({ rules, user });
  return new Ability(rules);
}

module.exports = {
  defineAbilitiesFor,
};
